"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FavoriteFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6,10.5 L3.16993185,7.70687487 C2.86839988,7.39232431 3.01347456,6.94806136 3.44967652,6.85614193 L7.3,6.3 L9.29344098,2.46171449 C9.36980599,2.31467692 9.55090956,2.2573855 9.69794712,2.3337505 C9.75695577,2.36439707 9.80411092,2.41377917 9.83200387,2.47413822 L11.6,6.3 L15.5369847,6.85593941 C15.8181458,6.85593941 16.2461513,7.34059321 15.8181458,7.70687487 L13,10.5 L13.988746,14.5680344 C14.0475311,14.8104401 13.7961282,15.0978699 13.4701313,14.9577636 L9.50001104,13 L5.53300553,14.9502027 C5.31268311,15.0917358 4.92179871,14.8757324 5,14.5482788 L6,10.5 Z" })));
};
FavoriteFilledSmall.displayName = 'FavoriteFilledSmall';
exports.default = FavoriteFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FavoriteFilledSmall.js.map